import { render } from "./EditFacebook.vue?vue&type=template&id=35a1fa76&scoped=true"
import script from "./EditFacebook.vue?vue&type=script&lang=js"
export * from "./EditFacebook.vue?vue&type=script&lang=js"

import "./EditFacebook.vue?vue&type=style&index=0&id=35a1fa76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a1fa76"]])

export default __exports__